@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.label {
  font-size: 12px;
  line-height: 12px;
  color: @labeled-info--text-color;
  margin-bottom: 3px;
}

.content {
  font-size: 14px;
  line-height: 16px;
}

.mdash {
  color: @labeled-info--text-color;
}

.spinner {
  transform: scale(0.5);
}
